import React, {Suspense} from "react";
import BackdropSpinner from "../../../shared/backdrop-spinner/BackdropSpinner";
import ErrorBoundary from "../../../shared/error-boundary/ErrorBoundary";
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";

interface Props {
    Component: React.FunctionComponent;
    Layout: React.ComponentType<any>;
    title?: string;
}

const RouteWrapper = ({ Component, Layout, title }: Props) => {
    const {pathname} = useLocation();
    const normalizedPath = pathname.length > 1 && pathname.endsWith("/")
        ? pathname.slice(0, -1)
        : pathname;
    const canonicalUrl = `https://genie.mk${normalizedPath}`;
    const noindexPrefixes = [
        "/auth",
        "/forgot-password",
        "/reset-password",
        "/email-confirmation",
        "/profile",
        "/admin-panel",
        "/client-panel",
        "/unsubscribe-newsletter",
    ];
    const isNoindex = noindexPrefixes.some((prefix) => (
        normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
    ));

    return (
        <>
            <Helmet>
                {title && (
                    <title>{title} | Genie</title>
                )}
                <link rel="canonical" href={canonicalUrl}/>
                <meta property="og:url" content={canonicalUrl}/>
                <meta name="twitter:url" content={canonicalUrl}/>
                {isNoindex ? (
                    <meta name="robots" content="noindex, nofollow"/>
                ) : null}
            </Helmet>
            <Layout>
                <ErrorBoundary>
                    <Suspense fallback={<BackdropSpinner />}>
                        <Component />
                    </Suspense>
                </ErrorBoundary>
            </Layout>
        </>
    );
};

export default RouteWrapper;
